import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
/** Common Components */
import Buttons from '../../../../components/ui/button/Buttons';
import { AppIcons } from '../../../../data/appIcons';
import FormCreator from '../../../../components/finalForms/FormCreator';
import { setFieldSetting } from '../../../../utils/FormFields/FieldsSetting/SetFieldSetting';
import { validationTypes } from '../../../../components/finalForms/libs/data/ValidationTypes';
/** RTK Query */
import {
  useAddProjectVersionMutation,
  useLazyGetProjectVersionByIdQuery,
  useUpdateProjectVersionMutation
} from '../../../../app/services/projectVersionAPI';
/** Common Services & Data Files */
import ToastService from '../../../../services/toastService/ToastService';
import projectVersionFormData from './config/ProjectVersion.data';
import { FieldSettingType } from '../../../../utils/Enums/commonEnums';
import { decryptUrlData } from '../../../../services/CryptoService';

const AddProjectVersion = (props) => {
  const ref = useRef();
  const [formData, setFormData] = useState(projectVersionFormData);
  // const ProjectId = useSelector((state) => state.project.projectData?.projectId);
  const { id } = useParams();
  let projectId = null;
  const projectdata = id ? decryptUrlData(id) : null;
  if (typeof projectdata === 'object' && projectdata !== null) {
    projectId = projectdata.projectId;
  } else if (projectdata) {
    projectId = projectdata;
  }
  // API'S Call
  const [addProjectVersion, {
    isSuccess: isProjectVersionAdded,
    isLoading: isProjectVersionAdding,
    data: addProjectVersionData
  },] = useAddProjectVersionMutation();

  const [updateProjectVersion, {
    isLoading: updateProjectVersionLoading,
    isSuccess: isSuccessUpdateProjectVersion,
    data: updateProjectVersionData
  }] = useUpdateProjectVersionMutation();

  const [getProjectVersionById, {
    isFetching: isProjectVersionfetching,
    isSuccess: isProjectVersionsuccess,
    data: ProjectVersionData
  },] = useLazyGetProjectVersionByIdQuery();
  
  //** useEffect's */
  useEffect(() => {
    formReset();
    if (props.selectedId) {
      getProjectVersionById(props.selectedId);
    }
  }, [props.selectedId, getProjectVersionById]);

  useEffect(() => {
    if (isProjectVersionsuccess && !isProjectVersionfetching && ProjectVersionData) {
      if (ProjectVersionData) {
        let Data = { ...formData };
        Data.initialState = {
          ...formData.initialState,
          projectVersion: ProjectVersionData.projectVersion,
          isRelease: ProjectVersionData.isRelease,
          releaseDate: ProjectVersionData.releaseDate ? new Date(ProjectVersionData.releaseDate) : null,
        };
        if (ProjectVersionData.isRelease === true) {
          setFieldSetting(
            projectVersionFormData,
            "releaseDate",
            FieldSettingType.DISABLED,
            false
          );
        }
        else {
          setFieldSetting(
            projectVersionFormData,
            "releaseDate",
            FieldSettingType.DISABLED,
            true
          );
        }
        setFormData(Data);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProjectVersionsuccess, isProjectVersionfetching, ProjectVersionData]);

  //** Funcation's */
  const handleSubmit = () => {
    const formData = ref.current.getFormData();
    if (!props.selectedId && formData) {
      if (formData) {
        const requestData = {
          ...formData,
          projectVersion: formData?.projectVersion,
          isRelease: formData?.isRelease || false,
          releaseDate: formData?.releaseDate ? formData?.releaseDate : null,
          projectId: projectId
        }
        addProjectVersion(requestData);
      }
    }
    else if (props.selectedId && formData) {
      const DataUpdate = {
        ...formData,
        projectVersion: formData?.projectVersion,
        isRelease: formData?.isRelease,
        releaseDate: formData?.releaseDate,
        projectVersionId: props.selectedId,
        projectId: projectId
      }
      updateProjectVersion(DataUpdate)
    }
  }

  useEffect(() => {
    if (isSuccessUpdateProjectVersion && updateProjectVersionData) {
      if (updateProjectVersionData.errorMessage.includes("exists")) {
        ToastService.warning(updateProjectVersionData.errorMessage);
        return;
      } else {
        ToastService.success(updateProjectVersionData.errorMessage);
        backToList();
        props.onSuccess();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessUpdateProjectVersion, updateProjectVersionData])


  useEffect(() => {
    if (isProjectVersionAdded && addProjectVersionData) {
      if (addProjectVersionData.errorMessage.includes("exists")) {
        ToastService.warning(addProjectVersionData.errorMessage);
        return;
      }
      else {
        ToastService.success(addProjectVersionData.errorMessage);
        backToList();
        props.onSuccess();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProjectVersionAdded, addProjectVersionData]);
  //** Funcation's */
  const formReset = () => {
    const projectForm = { ...projectVersionFormData };
    projectForm.initialState = { ...projectVersionFormData.initialState };
    setFormData(projectForm);
  }

  const backToList = () => {
    props.onSidebarClose();
    formReset();
  };

  const handleColumnChange = (dataField, updatedData) => {
    if (dataField === "isRelease") {
      const sectionIndex = projectVersionFormData.section.findIndex(sec =>
        sec.fields.some(field => field.dataField === "isRelease")
      );
      const section = projectVersionFormData.section[sectionIndex];
      const isReleaseField = section.fields.find(field => field.dataField === "isRelease");
      const checkedValue = updatedData?.isRelease ?? isReleaseField?.fieldSetting?.checked;
      const version = checkedValue === "true" || checkedValue === true;
      const updatedSection = {
        ...section,
        fields: section.fields.map(field =>
          field.dataField === "releaseDate"
            ? {
              ...field,
              fieldSetting: {
                ...field.fieldSetting,
              },
              validation: version ? [{ type: validationTypes.REQUIRE }] : []
            }
            : field
        )
      };
      const updatedFormData = {
        ...projectVersionFormData,
        section: projectVersionFormData.section.map((sec, index) =>
          index === sectionIndex ? updatedSection : sec
        )
      };
      setFieldSetting(updatedFormData, "releaseDate", FieldSettingType.DISABLED, !version);
      if (version === true) {
        const newForm = {
          ...updatedFormData,
          initialState: {
            ...updatedFormData.initialState,
            ...updatedData,
            releaseDate: null
          }
        };
        setFormData(newForm);
      } else {
        const newForm = {
          ...updatedFormData,
          initialState: {
            ...updatedFormData.initialState,
            ...updatedData,
            releaseDate: null
          }
        };
        setFormData(newForm);
      }
    }
  };

  return (
    <div className="">
      <form>
        <div className="row">
          <FormCreator
            config={formData}
            ref={ref}
            {...formData}
            onColumnChange={handleColumnChange} />
        </div>
      </form>
      <div className="row">
        <div className="col-12 ">
          <div className="form-btn d-flex justify-content-end button-align-45 mt-3">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={backToList}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              onClick={handleSubmit}
              buttonText={props.selectedId ? "Update" : "Add"}
              isLoading={isProjectVersionAdding || updateProjectVersionLoading}
              imagePath={AppIcons.AddIcon}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

AddProjectVersion.propTypes = {
  selectedId: PropTypes.number,
  onSidebarClose: PropTypes.func.isRequired,
};
export default AddProjectVersion;